import { Reveal } from "@/components/shared";
import { AUDIENCES } from "@/data/content";

export default function Audience() {
  return (
    <section className="border-y border-gold/10 bg-navy-900/60 py-16">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.08}>
            <div className="group border-t-2 border-gold/30 pt-6 transition-colors duration-500 hover:border-gold">
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-gold">{a.title}</p>
              <p className="mt-3 font-display text-xl font-semibold leading-snug text-slate-200 transition-colors duration-300 group-hover:text-white">
                "{a.quote}"
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
